import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { supabase } from '../supabaseClient';
import Footer from '../components/Footer';

const GOLD = '#c8a04e';
const GA   = (a) => `rgba(200,160,78,${a})`;
const W    = (a) => `rgba(255,255,255,${a})`;

const NAV_LINKS = [
  { label: 'Features', href: '/#features' },
  { label: 'Pricing',  href: '/#pricing'  },
  { label: 'FAQ',      href: '/#faq'      },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open,     setOpen]     = useState(false);
  const [user,     setUser]     = useState(null);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn, { passive: true });
    fn();
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => setUser(data?.user ?? null));
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, s) => setUser(s?.user ?? null));
    return () => subscription.unsubscribe();
  }, []);

  const lk      = { fontSize:13, fontWeight:500, color:W(0.45), textDecoration:'none', padding:'6px 12px', borderRadius:8, transition:'color 0.14s', whiteSpace:'nowrap', letterSpacing:'0.01em' };
  const lOn     = e => { e.currentTarget.style.color = W(0.9); };
  const lOff    = e => { e.currentTarget.style.color = W(0.45); };
  const pill    = { display:'inline-flex', alignItems:'center', padding:'8px 20px', borderRadius:10, background:'radial-gradient(ellipse 120% 80% at 50% 0%, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.025) 55%, rgba(255,255,255,0.015) 100%)', border:`1px solid ${W(0.09)}`, boxShadow:'0 4px 16px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.06)', color:W(0.82), fontSize:13, fontWeight:600, letterSpacing:'0.02em', textDecoration:'none', cursor:'pointer', transition:'all 0.15s' };
  const pillOn  = e => { e.currentTarget.style.background = 'radial-gradient(ellipse 120% 80% at 50% 0%, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0.045) 55%, rgba(255,255,255,0.025) 100%)'; e.currentTarget.style.borderColor = W(0.15); e.currentTarget.style.color = W(1); };
  const pillOff = e => { e.currentTarget.style.background = 'radial-gradient(ellipse 120% 80% at 50% 0%, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.025) 55%, rgba(255,255,255,0.015) 100%)'; e.currentTarget.style.borderColor = W(0.09); e.currentTarget.style.color = W(0.82); };

  return (
    <>
      <nav style={{ position:'fixed', top:0, left:0, right:0, zIndex:200, transition:'background 0.35s ease, border-color 0.35s ease, backdrop-filter 0.35s ease', background:scrolled ? 'rgba(0,0,0,0.75)' : 'transparent', backdropFilter:scrolled ? 'blur(20px)' : 'none', WebkitBackdropFilter:scrolled ? 'blur(20px)' : 'none', borderBottom:scrolled ? `1px solid ${W(0.07)}` : '1px solid transparent' }}>
        <div style={{ maxWidth:1120, margin:'0 auto', display:'grid', gridTemplateColumns:'1fr auto 1fr', alignItems:'center', gap:24, padding:'0 32px', height:68 }}>
          <Link to="/"><img src="/athena_logo.png" alt="Athena" style={{ height:64, width:64, display:'block', objectFit:'contain' }} /></Link>
          <div style={{ display:'flex', alignItems:'center', gap:2 }}>
            {NAV_LINKS.map(n => <a key={n.label} href={n.href} style={lk} onMouseEnter={lOn} onMouseLeave={lOff}>{n.label}</a>)}
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:10, justifyContent:'flex-end' }}>
            {user
              ? <Link to="/dashboard" style={pill} onMouseEnter={pillOn} onMouseLeave={pillOff}>Dashboard</Link>
              : <>
                  <Link to="/login"    style={lk}                       onMouseEnter={lOn}    onMouseLeave={lOff}>Sign In</Link>
                  <Link to="/register" style={{ ...pill, color:W(0.55) }} onMouseEnter={pillOn} onMouseLeave={pillOff}>Sign Up</Link>
                </>
            }
          </div>
        </div>
        <AnimatePresence>
          {open && (
            <motion.div initial={{ height:0, opacity:0 }} animate={{ height:'auto', opacity:1 }} exit={{ height:0, opacity:0 }} transition={{ duration:0.2 }} style={{ overflow:'hidden', background:'rgba(0,0,0,0.96)', borderTop:`1px solid ${W(0.07)}` }}>
              <div style={{ padding:'14px 32px 22px', display:'flex', flexDirection:'column', gap:4 }}>
                {NAV_LINKS.map(n => <a key={n.label} href={n.href} onClick={() => setOpen(false)} style={{ ...lk, display:'block' }}>{n.label}</a>)}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
      <div style={{ height:68 }} />
    </>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom:32, paddingBottom:32, borderBottom:`1px solid ${W(0.05)}` }}>
      <h2 style={{ fontSize:14, fontWeight:700, color:W(0.85), margin:'0 0 12px', letterSpacing:'-0.01em' }}>{title}</h2>
      <div style={{ fontSize:13.5, color:W(0.38), lineHeight:1.85 }}>{children}</div>
    </div>
  );
}

export default function TermsOfService() {
  return (
    <div style={{ minHeight:'100vh', background:'#000', position:'relative' }}>
      <div style={{ position:'fixed', inset:0, pointerEvents:'none', zIndex:0, opacity:0.03, backgroundImage:`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='256' height='256'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='256' height='256' filter='url(%23n)'/%3E%3C/svg%3E")` }} />
      <div style={{ position:'fixed', top:0, left:'20%', right:'20%', height:260, background:`radial-gradient(ellipse at 50% 0%, ${GA(0.06)} 0%, transparent 70%)`, pointerEvents:'none', zIndex:0 }} />
      <div style={{ position:'relative', zIndex:1 }}>
        <Navbar />
        <main style={{ maxWidth:720, margin:'0 auto', padding:'60px 24px 96px' }}>
          <motion.div initial={{ opacity:0, y:20 }} animate={{ opacity:1, y:0 }} transition={{ duration:0.45 }}>
            <p style={{ fontSize:10, fontWeight:700, color:W(0.2), letterSpacing:'0.22em', textTransform:'uppercase', margin:'0 0 14px' }}>Legal</p>
            <h1 style={{ fontSize:36, fontWeight:800, color:W(0.95), margin:'0 0 8px', letterSpacing:'-0.02em' }}>Terms of Service</h1>
            <p style={{ fontSize:13, color:W(0.25), margin:'0 0 40px' }}>Last updated: April 2026</p>

            <div style={{ position:'relative', background:'rgba(255,255,255,0.02)', border:`1px solid ${W(0.06)}`, borderRadius:20, padding:'40px 40px 8px' }}>
              <div style={{ position:'absolute', top:0, left:40, right:40, height:1, background:`linear-gradient(90deg, transparent, ${GA(0.18)}, transparent)` }} />

              <Section title="1. Acceptance of Terms">
                <p>By purchasing, downloading, or using any product or service offered by Athena ("we", "us", or "our"), you agree to be bound by these Terms of Service. If you do not agree, do not use our services.</p>
              </Section>

              <Section title="2. Use of Scripts & Software">
                <p style={{ marginBottom:10 }}>Athena provides recoil scripts and related software for use with games such as Rust. By using our software, you acknowledge and accept the following:</p>
                <ul style={{ paddingLeft:18, margin:0 }}>
                  <li style={{ marginBottom:6 }}>Our scripts are intended for personal, private use only.</li>
                  <li style={{ marginBottom:6 }}>You are solely responsible for how you use our software.</li>
                  <li>Using third-party scripts or modifications in online games may violate the terms of service of the respective game or platform.</li>
                </ul>
              </Section>

              <Section title="3. Server Bans & Game Bans">
                <p style={{ marginBottom:10 }}>If you are banned from a server, game, or platform as a result of using Athena's software or services:</p>
                <ul style={{ paddingLeft:18, margin:0 }}>
                  <li style={{ marginBottom:6 }}>Athena bears no responsibility whatsoever for any bans, account suspensions, or penalties you receive.</li>
                  <li style={{ marginBottom:6 }}>We will not provide compensation, refunds, or assistance related to any ban resulting from the use of our software.</li>
                  <li>You use our software at your own risk. You accept full liability for any consequences.</li>
                </ul>
              </Section>

              <Section title="4. Intellectual Property">
                <p>All software, scripts, designs, and content provided by Athena are the intellectual property of Athena. You may not redistribute, resell, decompile, reverse-engineer, or share our software without explicit written permission.</p>
              </Section>

              <Section title="5. License Keys">
                <p>Each license key is issued to one user only and is non-transferable. Sharing, selling, or distributing your license key to any third party is strictly prohibited and may result in immediate revocation of access without refund.</p>
              </Section>

              <Section title="6. Account Responsibility">
                <p>You are responsible for maintaining the confidentiality of your account credentials. Any activity that occurs under your account is your responsibility. Notify us immediately if you suspect unauthorized use of your account.</p>
              </Section>

              <Section title="7. Modifications to Service">
                <p>We reserve the right to modify, suspend, or discontinue any part of our services at any time without notice. We are not liable to you or any third party for any such modification, suspension, or discontinuation.</p>
              </Section>

              <Section title="8. Limitation of Liability">
                <p>To the fullest extent permitted by law, Athena shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services, including but not limited to game bans, account losses, or data loss.</p>
              </Section>

              <Section title="9. Changes to These Terms">
                <p>We may update these Terms of Service from time to time. Continued use of our services after any changes constitutes acceptance of the new terms. It is your responsibility to review these terms periodically.</p>
              </Section>

              <Section title="10. Contact">
                <p>For any questions regarding these Terms of Service, reach out via our <a href="https://discord.gg/9KWNw8CeZX" target="_blank" rel="noopener noreferrer" style={{ color:GOLD, textDecoration:'none', borderBottom:`1px solid ${GA(0.3)}` }}>Discord server</a> or email us at <a href="mailto:support@athenascripts.cc" style={{ color:GOLD, textDecoration:'none', borderBottom:`1px solid ${GA(0.3)}` }}>support@athenascripts.cc</a>.</p>
              </Section>
            </div>

            <div style={{ display:'flex', gap:24, marginTop:28 }}>
              <Link to="/privacy" style={{ fontSize:13, color:W(0.3), textDecoration:'none', transition:'color 0.15s' }} onMouseEnter={e => e.currentTarget.style.color=W(0.7)} onMouseLeave={e => e.currentTarget.style.color=W(0.3)}>Privacy Policy</Link>
              <Link to="/refunds" style={{ fontSize:13, color:W(0.3), textDecoration:'none', transition:'color 0.15s' }} onMouseEnter={e => e.currentTarget.style.color=W(0.7)} onMouseLeave={e => e.currentTarget.style.color=W(0.3)}>Refund Policy</Link>
            </div>
          </motion.div>
        </main>
        <Footer />
      </div>
    </div>
  );
}
